import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { mock_projects } from '../../utils/data';
import { LastProjectCard, TitleLarge } from '../../components';

const WelcomePage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<div className='px-sm-5'>
						<TitleLarge> Willkommen, Nikolay Malygin!</TitleLarge>
						<p className='text-center px-sm-3 px-md-5 mx-xl-5'>
							Herzlich willkommen bei "web check" - Ihrer zentralen Plattform für die
							Überprüfung von Website-Projekten. Nutzen Sie die umfassenden
							Prüfungsalgorithmen, um die Qualität und Performance Ihrer Websites zu
							verbessern. "web check" unterstützt Sie dabei, mögliche Fehler zu
							identifizieren und die Benutzererfahrung Ihrer Besucher zu maximieren.
						</p>
					</div>
					<div className='container mt-5'>
						<div className='row gy-3 justify-content-center'>
							{mock_projects.slice(-3).map((project) => (
								<LastProjectCard key={project.project_id} project={project} />
							))}
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default WelcomePage;
